import React, { useEffect, useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { BiSearchAlt, BiSolidFileExport } from 'react-icons/bi';
import { utils, writeFile } from 'xlsx';
import '../../shared/Shared.css';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { ToastContainer } from 'react-toastify';
import { VedikaService } from '../../services/VedikaService';
import * as moment from 'moment';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'jszip';
import 'datatables.net-buttons';

const LaporanClaim = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [listDataKlaim, setlistDataKlaim] = useState([]);
    const [periodeAwal, setperiodeAwal] = useState(new Date());
    const [periodeAkhir, setperiodeAkhir] = useState(new Date());

    const loadInit = () => {
        setIsLoading(true);
        let tglAwal = moment(periodeAwal).format('YYYY-MM-DD');
        let tglAkhir = moment(periodeAkhir).format('YYYY-MM-DD');
        const promise1 = VedikaService.getKlaimReport(`tglAwal=${tglAwal} 00:00:00&tglAkhir=${tglAkhir} 23:59:59`);
        const allPromise = Promise.all([promise1]);
        allPromise.then(val => {
            if (val[0].data.data.length > 0) {
                setlistDataKlaim(val[0].data.data);
            }
        })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handlePeriodeAwal = () => {
        setperiodeAwal($('#tglAwal').val());
    }
    const handlePeriodeAkhir = () => {
        setperiodeAkhir($('#tglAkhir').val());
    }

    const loadDtList = () => {
        $('#dt-klaim').DataTable({
            data: listDataKlaim,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: 'nocm',
                    width: '5%'
                },
                {
                    targets: [1],
                    data: 'namapasien',
                    width: '10%'
                },
                {
                    targets: [2],
                    data: 'nosep',
                    width: '10%'
                },
                {
                    targets: [3],
                    data: 'tglregistrasi',
                    width: '6%'
                },
                {
                    targets: [4],
                    data: 'namaruangan',
                    width: '8%'
                },
                {
                    targets: [5],
                    data: 'dpjp',
                    width: '10%'
                },
                {
                    targets: [6],
                    data: 'total',
                    width: '5%'
                },
                {
                    targets: [7],
                    data: 'tgl_verif',
                    width: '6%'
                },
                {
                    targets: [8],
                    data: 'petugas_verif',
                    width: '5%'
                },
                {
                    targets: [9],
                    data: 'tgl_klaim',
                    width: '6%'
                },
                {
                    targets: [10],
                    data: 'petugas_klaim',
                    width: '10%'
                }
            ],
            dom: 'fr<"#export-toolbar.toolbar">tip',
        })
    }

    const renderEl = () => {
        const elToolbar = createRoot(document.getElementById('export-toolbar'));
        elToolbar.render(<Row><Col md={2}><Form.Group as={Col} id="export">
            <div className="d-grid gap-2">
                <Button className='mtc-2' variant="secondary" size="sm" onClick={exportData}><BiSolidFileExport />Export Excel</Button>
            </div>
        </Form.Group></Col></Row>);
    }

    const headerExportData = [
        "No RM",
        "Nama",
        "SEP",
        "Tgl Pendaftaran",
        "Ruangan",
        "DPJP",
        "Tagihan",
        "Tgl Verif",
        "Petugas Verif",
        "Tgl Coding",
        "Petugas Coding",
        "Tgl Claim",
        "Petugas Claim",
    ];

    const exportData = () => {
        var data = $('#dt-klaim').DataTable()
            .columns()
            .data()
            .toArray();
        let arrExport = [];
        let lengthData = data[0].length;
        let lengthRows = data.length;
        for(let d=0;d<lengthData;d++){
            let arr=[];
            for(let i=0;i<lengthRows;i++){
                arr.push(data[i][d]);
            }
            arrExport.push(arr)
        }
        let wb = utils.book_new(),
            ws = utils.json_to_sheet(arrExport);
        utils.book_append_sheet(wb, ws, "Laporan");
        utils.sheet_add_aoa(ws, [headerExportData]);
        writeFile(wb, "Laporan Claim.xlsx")
    }

    useEffect(() => {
        loadInit()
    }, [])

    useEffect(() => {
        $('#dt-klaim').DataTable().clear().draw();
        loadDtList();
        renderEl();
    }, [listDataKlaim])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <ToastContainer />
            <Container fluid className='pb-5'>
                <Row>
                    <Col className='text-center bg-success text-white'>
                        <h5>Laporan Claim</h5>
                    </Col>
                </Row>
                <Row className='mb-3 pt-1'>
                    <Form.Group as={Col} controlId="tglAwal">
                        <Form.Label>Periode Awal</Form.Label>
                        <Form.Control size="sm" type="date" onChange={handlePeriodeAwal} ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="tglAkhir">
                        <Form.Label>Periode Akhir</Form.Label>
                        <Form.Control size="sm" type="date" onChange={handlePeriodeAkhir}></Form.Control>
                    </Form.Group>
                    {/* <Form.Group as={Col} controlId="ruangan2">
                    <Form.Label>Dpjp</Form.Label>
                    <Select
                        cacheOptions
                        styles={customStyles}
                        value={selectedDpjp}
                        getOptionLabel={e => e.namalengkap}
                        getOptionValue={e => e.id}
                        options={listDpjp}
                        onChange={handleChangeDpjp}
                    />
                </Form.Group> */}
                    <Form.Group as={Col} id="search">
                        <div className="d-grid gap-2">
                            <Button className='mtc-2' variant="success" size="sm" onClick={loadInit}><BiSearchAlt />Cari</Button>
                        </div>
                    </Form.Group>
                    {/* <Form.Group as={Col} id="export">
                        <div className="d-grid gap-2">
                            <Button className='mtc-2' variant="secondary" size="sm" onClick={exportData}><BiSolidFileExport />Export Excel</Button>
                        </div>
                    </Form.Group> */}
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <Table responsive="sm" size="sm" id='dt-klaim' bordered hover style={{ fontSize: 'smaller' }}>
                            <thead>
                                <tr>
                                    <th>No RM</th>
                                    <th>Nama</th>
                                    <th>SEP</th>
                                    <th>Tgl Pendaftaran</th>
                                    <th>Ruangan</th>
                                    <th>DPJP</th>
                                    <th>Tagihan</th>
                                    <th>Tgl Verif</th>
                                    <th>Petugas Verif</th>
                                    <th>Tgl Coding</th>
                                    <th>Petugas Coding</th>
                                </tr>
                            </thead>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
}

export default LaporanClaim;